const ClassesServices = {
	getClasses: () => Promise.resolve([]),
	getClassesById: () => Promise.resolve({}),
	getLessons: () => Promise.resolve([]),
	getPopularClasses: () => Promise.resolve([]),
	getClassesCycling: () => Promise.resolve([]),
	setLessons: () => Promise.resolve({}),
	cancelLessons: () => Promise.resolve({})
}

export default ClassesServices
